import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";
import logo from "../assets/logo.png";

export default function Header() {
  const [params] = useSearchParams();
  const [term, setTerm] = useState(params.get("q") || "");
  const navigate = useNavigate();
  const { count } = useCart();
  const { isAuthenticated, isAdmin, user, logout } = useAuth();

  const search = (e) => {
    e.preventDefault();
    navigate(term.trim() ? `/moviles?q=${encodeURIComponent(term.trim())}` : "/moviles");
  };

  return (
    <>
      <div className="notice">ENVÍO GRATIS A TODA CANARIAS Y PENÍNSULA • ENTREGA EN 24 - 72 H</div>

      <header className="masthead">
        <div className="wrap masthead__inner py-2">
          <Link to="/" className="logo" aria-label="ChachoPhone, inicio">
            {/* Chacho<em>Phone</em>
            <span aria-hidden="true" /> */}
            <img src={logo} alt="" height={70}/>
          </Link>

          <form className="masthead__search" onSubmit={search} role="search">
            <input
              type="search"
              value={term}
              onChange={(e) => setTerm(e.target.value)}
              placeholder="Busca por marca o modelo — Samsung, iPhone 15…"
              aria-label="Buscar móviles"
            />
            <button type="submit">Buscar</button>
          </form>

          <nav className="masthead__nav">
            <Link to="/moviles">Móviles</Link>

            {isAdmin && <Link to="/admin">Admin</Link>}

            {isAuthenticated ? (
              <>
                <Link to="/cuenta">{user?.name?.split(" ")[0] || "Mi cuenta"}</Link>
                <button className="linkish" onClick={logout} style={{ fontWeight: 500, textDecoration: "none" }}>
                  Salir
                </button>
              </>
            ) : (
              <Link to="/login">Entrar</Link>
            )}

            <Link to="/carrito" className="cartlink">
              Carrito
              <span className="cartlink__count">{count}</span>
            </Link>
          </nav>
        </div>
      </header>
    </>
  );
}
